import React from 'react';
import { ConfigContext } from '../../../utils/config';
import * as Dumb from '../dumb';
export default (() => {
  const {
    onClose
  } = React.useContext(ConfigContext);
  return React.createElement(Dumb.Footer, {
    onDismissClicked: onClose
  });
});